import DSSTitrationSchemes from 'dashboard/templates/views/DSS/DSSTitrationSchemes';

export default {
  path: 'titration-schemes',
  name: 'DSSTitrationSchemes',
  component: DSSTitrationSchemes,
  meta: {
    // title: 'MDSS - Titration Schemes',
    title: t => `MDSS - ${t('dss.titrationSchemes')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true,
  }
};
